// extracted by mini-css-extract-plugin
export var createdDate = "_gp-1";
export var divider = "_gp-2";
export var headerDivider = "_gp-3";
export var messagesCard = "_gp-0";
export var messagesContainer = "_gp-7";
export var messagesContainerWrapper = "_gp-4";
export var pointerCapturingButtonBoxes = "_gp-a";
export var showLeftPanelButton = "_gp-9";
export var showMoreButton = "_gp-c";
export var showMoreButtonContainer = "_gp-b";
export var summaryTitle = "_gp-6";
export var systemMessageCardWrapper = "_gp-d";
export var topButtons = "_gp-8";
export var withPadding = "_gp-5";